import "./StickyButton.css";

export default function StickyButton({ disabled, text = "Continue" }) {
  return (
    <div className="sticky-button">
      <input type="submit" value={text} className="btn btn--primary" disabled={disabled} />
    </div>
  );
}
